module.exports = __webpack_public_path__ + "static/media/6.e69a3e5e.jpg";